import { useState } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getInboxChannelsTableUrl } from 'conversations-external-deep-links/urls';
import { getInboxId, getPageName } from '../../messenger-connections/operators/getters';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReconnectFBMPageBanner = ({
  messengerConnection
}) => {
  const inboxId = getInboxId(messengerConnection);
  const [bannerIsDissmissed, setBannerIsDissmissed] = useState(false);
  if (bannerIsDissmissed) return null;
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "danger",
    closeable: true,
    onClose: () => setBannerIsDissmissed(true),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "MessagesApp.ReconnectFBMPageBanner.title",
      options: {
        messengerPageName: getPageName(messengerConnection)
      }
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "MessagesApp.ReconnectFBMPageBanner.description"
    }), /*#__PURE__*/_jsx(UIButton, {
      className: "m-left-3",
      href: getInboxChannelsTableUrl({
        inboxId
      }),
      use: "tertiary",
      size: "extra-small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.ReconnectFBMPageBanner.reconnectButton"
      })
    })]
  });
};
ReconnectFBMPageBanner.displayName = 'ReconnectFBMPageBanner';
export default ReconnectFBMPageBanner;